import { render } from "./FullWidthCta.vue?vue&type=template&id=2540a502"
import script from "./FullWidthCta.vue?vue&type=script&lang=js"
export * from "./FullWidthCta.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__